import { useQuery } from '@tanstack/react-query'
import { getPubAuthorities } from '@/api/filterService'

interface UsePubAuthoritiesOptions {
  jurisdictionUuids: string[]
  enabled?: boolean
}

/**
 * Custom hook for fetching publishing authorities based on selected jurisdictions.
 *
 * Only fetches when jurisdictions are selected and enabled is true.
 */
export function usePubAuthorities(options: UsePubAuthoritiesOptions) {
  const { jurisdictionUuids, enabled = true } = options

  // Sort for stable cache keys regardless of selection order
  const sortedUuids = [...jurisdictionUuids].sort()

  return useQuery({
    queryKey: ['pubAuthorities', sortedUuids],
    queryFn: () => getPubAuthorities(jurisdictionUuids),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10,
    enabled: enabled && jurisdictionUuids.length > 0,
    retry: 2,
  })
}
